export const startExam = () => async dispatch => {
    dispatch({ type: 'EXAM_LOADING' });
}

export const saveExamAnswer = (id, typeId, answers, mark, userMark) => async dispatch => {
    dispatch({ type: 'EXAM_SAVE_ANSWER', id, typeId, answers, mark, userMark });
}